"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateConvert = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _dayjs = _interopRequireDefault(require("dayjs"));
var _localizedFormat = _interopRequireDefault(require("dayjs/plugin/localizedFormat"));
_dayjs.default.extend(_localizedFormat.default);
class DateConvert {
  constructor() {
    (0, _defineProperty2.default)(this, "type", "date");
    (0, _defineProperty2.default)(this, "label", "Date");
    (0, _defineProperty2.default)(this, "description", "Convert timestamp to a formatted date.");
    (0, _defineProperty2.default)(this, "settings", {
      format: {
        type: "literal",
        title: "Date Format",
        description: "Formatting string for the date.",
        help: "Uses [Day.js](https://day.js.org/docs/en/display/format), see the [Day.js docs](https://day.js.org/docs/en/display/format) for details.",
        valueType: "string",
        default: "lll"
      }
    });
  }
  editorLabel(params) {
    return (params === null || params === void 0 ? void 0 : params.format) || "lll";
  }
  dependencies(context, params, resolver) {
    return (params === null || params === void 0 ? void 0 : params.format) || "lll";
  }
  create(deps, batcher) {
    return value => {
      let timestamp;
      if (typeof value === "number") {
        timestamp = value;
      } else if (typeof value === "string") {
        timestamp = parseInt(value);
        if (isNaN(timestamp)) {
          timestamp = 0;
        }
      }
      if (timestamp) {
        return _dayjs.default.unix(timestamp).format(deps);
      }
      return null;
    };
  }
}
exports.DateConvert = DateConvert;
//# sourceMappingURL=DateConvert.js.map